<section aria-label="notification banner">
    <div>
        <cms-text id="notification-header" class="header" *ngIf="pageData.header" [originalText]="pageData.header" color="force"></cms-text>
        <cms-text id="notification-description" *ngIf="pageData.description" [originalText]="pageData.description" color="force"></cms-text>
        <cms-text class="link" *ngIf="pageData.link" [originalText]="pageData.link" color="force"></cms-text>
    </div>
    <button class="close-btn" *ngIf="displayCloseIcon" [attr.aria-label]="pageData.closeAriaLabel" (click)="close()">
        <xm-media-image [imageOptions]="closeIconOptions" size="width" center="vert"></xm-media-image>
    </button>
</section>
